export default __webpack_public_path__ + "media/images/croix-rouge-16-c191c18dff036236ab79c80bc84101f2.png";